import React from "react";

const FloorBorder = ({ x = 10, y = 10, width = 1580, height = 780, ...props }) => (
  <image
    href={`${process.env.PUBLIC_URL}/assets/images/floor-plan-australia.svg`}
    x={x}
    y={y}
    width={width}
    height={height}
    preserveAspectRatio="xMidYMid meet"
    {...props}
  />
);

export default FloorBorder;
